import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-exodus-bg text-exodus-text">
      <Nav />
      <article className="max-w-3xl mx-auto px-6 lg:px-12 pt-36 pb-32">
        <p className="eyebrow"><span className="gold-divider" />Legal · Privacy</p>
        <h1 className="font-display text-5xl lg:text-6xl mt-4 leading-[0.95]">Privacy Policy</h1>
        <p className="text-sm text-exodus-muted mt-4">Last updated: February 2026</p>

        <div className="prose-exodus mt-12 space-y-8 text-exodus-text/90 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl gold-text">1. Who We Are</h2>
            <p className="mt-3">
              EXODUS LIFE &amp; WEALTH is a private wealth-advisory practice operated by Leon Butts,
              a licensed independent insurance advisor (GA · AL · IA · ME · MD · PA · SC).
              This Privacy Policy explains what we collect, why, and your rights.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">2. What We Collect</h2>
            <ul className="list-disc list-inside space-y-2 mt-3">
              <li><strong>Identity:</strong> name, email, phone (only if you provide them)</li>
              <li><strong>Quiz answers:</strong> the choices you make in the Find My Fit assessment</li>
              <li><strong>Calculator inputs:</strong> age, contribution amounts, retirement age</li>
              <li><strong>Payment metadata:</strong> Stripe-issued session IDs and payment status (we never store card numbers)</li>
              <li><strong>Usage logs:</strong> standard IP + browser data for security and abuse prevention</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">3. How We Use It</h2>
            <ul className="list-disc list-inside space-y-2 mt-3">
              <li>To match you with the right strategy (IUL, Annuity, Whole Life) and prepare for our consult</li>
              <li>To send your strategic-fit results, receipts, and educational follow-ups</li>
              <li>To process your refundable consult deposit via Stripe</li>
              <li>To improve the educational content and the quiz funnel (anonymized aggregates only)</li>
            </ul>
            <p className="mt-3">
              <strong>We never sell your data.</strong> We never share it with third-party marketers.
              The only third parties we use are operational: Stripe (payments), Resend (email delivery),
              ElevenLabs (audio narration), and Google (Meet / Calendar).
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">4. Your Rights</h2>
            <p className="mt-3">
              You may request a copy of everything we have on you, ask us to correct it, or ask us to
              delete it entirely. Email <a href="mailto:Leon@exoduslifeandwealth.com" className="gold-text underline">Leon@exoduslifeandwealth.com</a> with the subject line "Privacy Request" and we'll act within 30 days.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">5. Retention</h2>
            <p className="mt-3">
              We keep quiz answers and lead records as long as you remain a prospect or client. After
              an explicit deletion request, we purge within 30 days — except records we're legally
              required to retain (insurance regulators may require 5-7 years for licensed-advisor activity).
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">6. Security</h2>
            <p className="mt-3">
              Data is stored on encrypted servers. Authentication uses JWT. Payment data never touches
              our servers — Stripe handles it directly under PCI-DSS compliance.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">7. Children</h2>
            <p className="mt-3">
              EXODUS LIFE &amp; WEALTH is for adults. We do not knowingly collect information from
              anyone under 18. If you believe a minor's data is in our system, email us and we'll remove it.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">8. Disclosures</h2>
            <p className="mt-3">
              This site is educational. Nothing here is tax, legal, or investment advice. All product
              illustrations are projections, not guarantees. Final figures come from the issuing carrier
              under a private consult.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">9. Changes</h2>
            <p className="mt-3">
              If we update this policy, we'll change the "Last updated" date above and notify active
              clients by email. Continued use after a change constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl gold-text">10. Contact</h2>
            <p className="mt-3">
              Leon Butts · EXODUS LIFE &amp; WEALTH<br />
              <a href="mailto:Leon@exoduslifeandwealth.com" className="gold-text underline">Leon@exoduslifeandwealth.com</a>
            </p>
          </section>
        </div>
      </article>
      <Footer />
    </div>
  );
}
